(function ($) {

    $.fn.ariaShow = function () {
        return this.each(function () {
            $(this).attr('aria-hidden', 'false').removeClass('hidden');
        });
    };

    $.fn.ariaHide = function () {
        return this.each(function () {
            $(this).attr('aria-hidden', 'true').addClass('hidden');
        });
    };

    $.fn.ariaHideSrOnly = function (alsoVisuallyDisable) {

        alsoVisuallyDisable = typeof alsoVisuallyDisable !== 'undefined' ? !!alsoVisuallyDisable : false;

        function hide($elem) {
            $elem.attr('aria-hidden', 'true').prop('aria-hidden', true);
            if (alsoVisuallyDisable) {
                $elem.addClass('visually-disabled');
            }
        }

        return this.each(function () {

            // Hide the focusable child elements, and make them unfocusable
            $(this).find('*:focusable').each(function (itemK, item) {

                // Get item data
                var $item = $(item);
                var itemTabIndex = $item.attr('tabindex');
                var itemHidden = $item.attr('aria-hidden');

                // Set tab index to -1, and cache the old value
                $item.attr('tabindex', -1);
                $item.attr('data-cached-tabindex', itemTabIndex);
            });

            // Hide the root element
            hide($(this));
        });
    };

    $.fn.ariaShowSrOnly = function () {

        function show($elem) {
            $elem.removeAttr('aria-hidden').removeProp('aria-hidden').removeClass('visually-disabled');
        }

        return this.each(function () {

            // Show the focusable child elements, and make them focusable
            $(this).find('*:focusable').each(function (itemK, item) {

                // Get item data
                var $item = $(item);
                var cachedTabIndex = $item.attr('data-cached-tabindex');
                var cachedHidden = $item.attr('data-cached-aria-hidden');

                // Restore cached tabindex or remove tabindex
                if (typeof cachedTabIndex == 'undefined') {
                    $item.removeAttr('tabindex');
                } else {
                    $item.removeAttr('data-cached-tabindex');
                    $item.attr('tabindex', cachedTabIndex);
                }
            });

            // Show the root element
            show($(this));
        });
    };

}(jQuery));